import React from "react";

const ProjectSnapshot = ({ source, title }) => {
  return (
    <div className="p-5">
      <div className="px-4  rounded-sm">
        <img
          src={source}
          alt={title}
          className="transform sm:hover:scale-110 transition delay-300 duration-300 ease-in-out sm:h-60  object-contain "
        />
      </div>
      <h3 className="text-xl font-semibold text-center mt-1">{title}</h3>
    </div>
  );
};

export default ProjectSnapshot;
